module.exports = __webpack_public_path__ + "static/media/vertical-bars.1156a27b.jpg";